import React, { useState } from 'react';

const AppointmentForm = (props) => {
    const { formTitle, formSubTitle, formBtn, formBtnClass } = props;
    
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        website: '',
        message: '',
        formType: 'appointment'
    });
    
    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('Submitting...');

        try {
            const response = await fetch('https://www.tavsftpl.com/api/send-email', {
            //const response = await fetch('http://localhost:8080/api/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            if (response.ok) {
                setStatus('Form submitted successfully!');
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    website: '',
                    message: '',
                    formType: 'appointment'
                });
                setTimeout(() => setStatus(''), 3000); // Clear status after 3 seconds
            } else {
                setStatus(`Error: ${result.error || 'Submission failed'}`);
            }
        } catch (error) {
            console.error('Submission error:', error);
            setStatus('Network error - is the server running?');
        }
    };

    return (
        <main>
            <div className="appointment-style white-bg">
                <div className="form-title">
                    <h3 className="title">{formTitle ? formTitle : 'Schedule Your Appointment'}</h3>
                    <p className="desc">{formSubTitle ? formSubTitle : 'We here to help you 24/7 with experts'}</p>
                </div>
                <form className="appointment-form" onSubmit={handleSubmit}>
                    <input 
                        type="text" 
                        name="name" 
                        placeholder="Name" 
                        value={formData.name}
                        onChange={handleChange}
                        required 
                    />
                    <input 
                        type="email" 
                        name="email" 
                        placeholder="E-Mail" 
                        value={formData.email}
                        onChange={handleChange}
                        required 
                    />
                    <input 
                        type="text" 
                        name="phone" 
                        placeholder="Phone Number" 
                        value={formData.phone}
                        onChange={handleChange}
                        required 
                    />
                    <input 
                        type="text" 
                        name="website" 
                        placeholder="Your Website" 
                        value={formData.website}
                        onChange={handleChange}
                        required 
                    />
                    <input
                        name="message"
                        placeholder="Your Message Here"
                        value={formData.message}
                        onChange={handleChange}
                    ></input>

                    <button 
                        type="submit" 
                        className={formBtnClass ? formBtnClass : 'submit'}
                    >
                        {formBtn ? formBtn : 'Submit Now'}
                    </button>
                    {status && <p className="form-status">{status}</p>}
                </form>
            </div>
        </main>
    );
};

export default AppointmentForm;
